<template>
  <question-card
    @submit="submit"
    :disabled="buttonDisabled"
    :buttonText="UIComponentData.Button.Translations[questionnaireLead.Language]"
  >
    <template #title>
      {{UIComponentData.Header.Translations[questionnaireLead.Language]}}
    </template>
    <div class="range-slider">
      <div class="range-slider__value">
        <template v-if="questionnaireLead.AnnualHouseholdIncome!=0">
          <span v-if="questionnaireLead.AnnualHouseholdIncome != 275000" class="range-slider__currency">{{ start }}</span>
          <span v-if="questionnaireLead.AnnualHouseholdIncome != 275000" class="range-slider__text">to</span>
          <span v-if="questionnaireLead.AnnualHouseholdIncome != 275000" class="range-slider__currency">{{ end }}</span>
          <span v-if="questionnaireLead.AnnualHouseholdIncome == 275000">$250,000+</span>
        </template>
        <span v-else>$0</span>
      </div>
      <v-slider
        min="0"
        max="275000"
        step="25000"
        v-model="questionnaireLead.AnnualHouseholdIncome"
      ></v-slider>
      <div class="range-slider__extremums">
        <span>$0</span>
        <span>$250k+</span>
      </div>
    </div>
  </question-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import QuestionCard from '@/components/QuestionCard.vue';

export default {
  name: 'household-income-step',
  data() {
    return {
      sliderValue: 0,
    };
  },
  components: {
    QuestionCard,
  },
  props: {
    UIComponentData: {
      type: Object,
      required: true
    },
    UIId: Number
  },
  computed: {
    ...mapGetters(['questionnaireLead']),
    start() {
      return parseInt(this.questionnaireLead.AnnualHouseholdIncome) > 25000
        ? '$'+(parseInt(this.questionnaireLead.AnnualHouseholdIncome) - 24999).toLocaleString('en-US', { style: 'decimal', currency: 'USD' })
        : '$0';
    },
    end() {
      return '$'+(parseInt(this.questionnaireLead.AnnualHouseholdIncome) || 25000).toLocaleString('en-US', { style: 'decimal', currency: 'USD' });
    },
    buttonDisabled() {
      return this.questionnaireLead.AnnualHouseholdIncome == 0;
    },
  },
  methods: {
    ...mapActions(['mutateLead']),
    submit() {
      if(this.UIId!=null){
        if(this.questionnaireLead.StepId==null||this.UIId > this.questionnaireLead.StepId){
          this.questionnaireLead.StepId = this.UIId
          this.mutateLead(this.questionnaireLead);
        }
      }
      this.$emit('route-to-next-slide',false);
    },
  },
  created() {
    if(!this.questionnaireLead.AnnualHouseholdIncome)
      this.$set(this.questionnaireLead, 'AnnualHouseholdIncome',0);
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';

.range-slider {
  width: 80%;
  margin: 0px auto;
  &__value {
    display: flex;
    justify-content: center;
    font-weight: 600;
    margin-bottom: 10px;
  }
  &__text {
    margin: 0 10px;
  }
  &__slider {
    width: 100%;
  }
  &__extremums {
    display: flex;
    justify-content: space-between;
    opacity: 0.7;
  }
}
::v-deep .v-slider__thumb{
  &.primary{
    background-color: $slider-active-color !important;
    border-color: $slider-active-color !important;
    color: $slider-active-color !important;
  }
}

::v-deep .v-slider__track-fill{
  &.primary{
    background-color: $slider-active-color !important;
    border-color: $slider-active-color !important;
  }
}

::v-deep .v-slider__track-background{
  &.primary{
    &.lighten-3{
      background-color: $slider-inactive-color !important;
      border-color: $slider-inactive-color !important;
    }
  }
}

</style>
